import axios from 'axios';
import { handleResponse } from './HelperService';

const getCountryAll = (params, onSuccess, onError) => {
    const response = axios.get('v1/county', { params });
    return handleResponse(response, onSuccess, onError);
};
const getProvince = (id, onSuccess, onError) => {
    const response = axios.get(`v1/county/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const getSeries = (params, onSuccess, onError) => {
    const response = axios.get('v1/series', { params });
    return handleResponse(response, onSuccess, onError);
};
const getDebitorAccount = (params, onSuccess, onError) => {
    const response = axios.get('v1/glaccount', { params });
    return handleResponse(response, onSuccess, onError);
};
const getPPN = (params, onSuccess, onError) => {
    const response = axios.get('v1/ppn', { params });
    return handleResponse(response, onSuccess, onError);
};
const getPO = (params, onSuccess, onError) => {
    const response = axios.get(`v1/purchaseorder`, { params });
    return handleResponse(response, onSuccess, onError);
};
const getListProduk = (params, onSuccess, onError) => {
    const response = axios.get(`v1/product`, { params });
    return handleResponse(response, onSuccess, onError);
};
const getPPH = (params, onSuccess, onError) => {
    const response = axios.get(`v1/pph`, { params });
    return handleResponse(response, onSuccess, onError);
};
const getPromoMIReguler = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-campaignreguler`, payload);
    return handleResponse(response, onSuccess, onError);
};
const getPromoMIPreo = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-campaignpreorder`, payload);
    return handleResponse(response, onSuccess, onError);
};
const createPOHeader = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder`, payload);
    return handleResponse(response, onSuccess, onError);
};
const updatePOHeader = (no, payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder/${no}`, payload);
    return handleResponse(response, onSuccess, onError);
};
const getStok = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-stock`, payload);
    return handleResponse(response, onSuccess, onError);
};
const applyCampaign = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/campaign`, payload);
    return handleResponse(response, onSuccess, onError);
};
const getOrderType = (params, onSuccess, onError) => {
    const response = axios.get(`v1/ordertype`, { params });
    return handleResponse(response, onSuccess, onError);
};
const createPODetail = (no, payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder/item/${no}`, payload);
    return handleResponse(response, onSuccess, onError);
};
const deletePODetail = (id, payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-delete/item/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};
const updatePPN = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/purchaseorderdt/${id}/ppn`, payload);
    return handleResponse(response, onSuccess, onError);
};
const updatePODetail = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/purchaseorderdt/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};
const getPOHeader = (id, onSuccess, onError) => {
    const response = axios.get(`v1/purchaseorder/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const getCustomer = (params, onSuccess, onError) => {
    const response = axios.get(`v1/customer`, { params });
    return handleResponse(response, onSuccess, onError);
};
const updateDelivery = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/purchaseorderdt/${id}/delivery`, payload);
    return handleResponse(response, onSuccess, onError);
};
const updateCustomer = (kode, payload, onSuccess, onError) => {
    const response = axios.post(`v1/customer-update/${kode}`, payload);
    return handleResponse(response, onSuccess, onError);
};
const updateAddressCustomer = (kode, address_kode, payload, onSuccess, onError) => {
    const response = axios.post(`v1/customer-update/${kode}/${address_kode}`, payload);
    return handleResponse(response, onSuccess, onError);
};
const submitDM = (id, payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-submit-dm/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};
const submitDeduction = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-additional-discount-submit-approval`, payload);
    return handleResponse(response, onSuccess, onError);
};
const createPayment = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder_payment`, payload);
    return handleResponse(response, onSuccess, onError);
};
const deletePayment = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/purchaseorder_payment/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const createTax = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder_tax`, payload);
    return handleResponse(response, onSuccess, onError);
};
const deletePOHeader = (id, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-delete/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const getNPWP = (id, onSuccess, onError) => {
    const response = axios.get(`v1/purchaseorder-customernpwp/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const getAddress = (id, onSuccess, onError) => {
    const response = axios.get(`v1/purchaseorder-customeraddress/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const getCustInfo = (id, onSuccess, onError) => {
    const response = axios.get(`v1/purchaseorder-customer/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const getListDiskon = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-additional-discount-list`, payload);
    return handleResponse(response, onSuccess, onError);
};
const ApplyListDiskon = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-additional-discount-apply`, payload);
    return handleResponse(response, onSuccess, onError);
};
const calculateAllCampaign = (docnumpo, onSuccess, onError) => {
    const response = axios.get(`v1/purchaseorder-calculate-all-campaign/${docnumpo}`);
    return handleResponse(response, onSuccess, onError);
};
const completePO = (id, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-submit-by-dm-manual/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const pendingDMPO = (id, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-submit-dm-manual/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const submitPOMHC = (nomor, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-po-mhc-manual/${nomor}`);
    return handleResponse(response, onSuccess, onError);
};
const journey = (id, onSuccess, onError) => {
    const response = axios.get(`v1/journey/${id}`);
    return handleResponse(response, onSuccess, onError);
};
const submitSL = (trans, id, payload, onSuccess, onError) => {
    const response = axios.post(`v1/purchaseorder-submit-sl-sap/${trans}/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};
export {
    getCountryAll,
    getProvince,
    updateCustomer,
    getSeries,
    getDebitorAccount,
    getPPN,
    getPO,
    getListProduk,
    getPPH,
    getPromoMIReguler,
    createPOHeader,
    getStok,
    applyCampaign,
    getOrderType,
    createPODetail,
    deletePODetail,
    updatePPN,
    getPOHeader,
    getCustomer,
    updateDelivery,
    updatePODetail,
    updateAddressCustomer,
    submitDM,
    createPayment,
    deletePayment,
    createTax,
    deletePOHeader,
    getPromoMIPreo,
    getNPWP,
    getAddress,
    getCustInfo,
    getListDiskon,
    ApplyListDiskon,
    submitDeduction,
    updatePOHeader,
    calculateAllCampaign,
    completePO,
    pendingDMPO,
    journey,
    submitSL,
    submitPOMHC
};
